import fetchModule from "./fetchingData";
import { createSendForm } from "./form";
import API from "./../configs/API";
import { useState } from "react";

const OptionalParams = [
  "condition",
  "cityid",
  "marketerdataproviderid",
  "marketerofficeid",
  "marketerfinalid",
  "marketercoordinationid",
  "marketerpersonid"
];
const GetHistoryData = async (
  params,
  pageid,
  sortfield = "lastupdate",
  sortdirection = "desc"
) => {
  const Form = OptionalParams.reduce((prev, current) => {
    const value = params[current] ? params[current] : -1;
    prev[current] = value;
    return prev;
  }, {});
  let response = await fetchModule.post(
    "",
    createSendForm(
      {
        type: API.getHistory,
        sortfield,
        sortdirection,
        pagesize: 10,
        pageid,
        ...Form
      },
      false,
      "multiPart"
    )
  );
  return response;
};

const useHistoryData = params => {
  const [item, setItem] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  let resCount;
  const FetchHistory = async page => {
    const { sortfield, sortdirection, ...rest } = params;
    let res = await GetHistoryData(rest, page, sortfield, sortdirection);
    if (res === "empty") {
      res = [];
    } else {
      res = eval(res);
      resCount = res[0].DataCount;
    }
    if (resCount && item.length != resCount) {
      setItem(prev => [...prev, ...res]);
    } else {
      setHasMore(false);
    }
  };
  return [item, hasMore, FetchHistory];
};
export default useHistoryData;
